import { yupResolver } from "@hookform/resolvers/yup";
import { ChevronLeftIcon, EnterIcon } from "@radix-ui/react-icons";
import { Button, Card, Flex, Spinner } from "@radix-ui/themes";
import { useForm, Controller } from "react-hook-form";
import toast from "react-hot-toast";
import { useMutation } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { EntityType } from "../../../types/ScientificModule";
import { routes } from "../../../routes";
import { RootState } from "../../../redux/store";
import SelectComponent from "../../../components/inputs/Select/SelectComponent";
import { Countries, Country } from "../../../utils/codes";
import { updateEntity } from "../../../services/scientific/entity";
import { CreateEntityFormValidation } from "./CreateEntityValidationForm";
import { resetEntitiesData } from "../../../redux/slices/scientific/entities";
import TextFieldComponent from "../../../components/inputs/Textfield/TextfieldComponent";

export const UpdateEntity = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const entityData = useSelector((state: RootState) => state.entities);

  const mutation = useMutation({ mutationFn: updateEntity, mutationKey: "updateEntity" });

  const { control, handleSubmit, formState: { errors } } = useForm<EntityType>({
    resolver: yupResolver(CreateEntityFormValidation),
    defaultValues: entityData,
    mode: "onBlur",
    reValidateMode: "onBlur",
    shouldUseNativeValidation: false,
  });

  const onSubmit = handleSubmit(async (data) => {
    try {
      const result = await mutation.mutateAsync(data);
      if (result) {
        toast.success("Entidade atualizada com sucesso!");
        handleBack();
      }
    } catch (err: any) {
      toast.error(`${mutation.error ?? err?.message}`);
    }
  });

  const handleBack = () => {
    dispatch(resetEntitiesData());
    navigate(routes.entities);
  };

  return (
    <form onSubmit={onSubmit} noValidate>
      <Card size="1">
        <Flex direction="column" gap="4">
          <TextFieldComponent name="description" label="Descrição" control={control} errors={errors} fieldProps={{ placeholder: "Descrição" }} required={true}/>
          <SelectComponent
                name="country"
                label="País"
                control={control}
                errors={errors}
                options={Countries?.map((country:Country) => ({
                  value: country.code,
                  label: country.label ?? "",
                }))}
                style={{width:'100%'}} 
                required={true}
              />
          <Flex direction="row" gap="3" justify="end">
            <Button type="button" variant="soft" color="gray" onClick={handleBack} disabled={mutation.isLoading}>
              <ChevronLeftIcon /> Voltar
            </Button>
            <Button type="submit" disabled={mutation.isLoading}>
              {mutation.isLoading ? <Spinner /> : <EnterIcon />}
              Atualizar
            </Button>
          </Flex>
        </Flex>
      </Card>
    </form>
  );
};
